import { UseFormReturn } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import useRewardQuery from "../../hooks/useRewardQuery.hook";
import ErrorCenterIcon from "../../icons/exclamationTriangleCenter.icon";
import LoadingOvalCenterIcon from "../../icons/loadingOvalCenter.icon";
import { RewardListFilter } from "../../types/reward";
import RewardListRow from "./rewardRow.comp";
import NoRecordDisplay from "../common/noRecord.comp";
import Link from "next/link";
import { CSSProperties } from "react";

export default function RewardListComp({
  methods,
  customerId,
}: {
  methods: UseFormReturn<RewardListFilter, any>;
  customerId?: string | string[];
}) {
  const { t, msg } = useTranslation();
  const { data: rewards, isLoading, isError, error } = useRewardQuery(methods);

  if (isError) return <ErrorCenterIcon reason={error.message} />;
  if (isLoading) return <LoadingOvalCenterIcon />;

  return (
    <>
      {rewards && rewards.list.length > 0 && (
        <Link className="underline email" href={`/rewards?customerId=${customerId}`}>
          {t(msg.customer.viewAllRewards)}
        </Link>
      )}
      <section
        data-type="grid"
        id="product-section"
        className="my-grid pt-6 lg:pt-0 mb-6"
        style={{ "--grid-columns": 6 } as CSSProperties}
      >
        <div className="my-grid-header gap-x-4">
          <div>{t(msg.order.orderNumber)}</div>
          <div>{t(msg.general.name)}</div>
          <div>{t(msg.reward.purchaseDate)}</div>
          <div>{t(msg.reward.expiresOn)}</div>
          <div>{t(msg.reward.rewardStatus)}</div>
          <div>{t(msg.reward.points)}</div>
        </div>

        {rewards && rewards.list.length > 0 ? (
          rewards.list.map((r) => <RewardListRow reward={r} key={r.id} />)
        ) : (
          <div className="col-span-full">
            <NoRecordDisplay />
          </div>
        )}
      </section>
    </>
  );
}
